import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import DropdownItem from './DropdownItem'
import styles from './styles'

const DropDown = ({ items: propItems, style, itemCss }) => {
  const containerRef = useRef()
  const [isOpen, setIsOpen] = useState(false)
  const [mainItem, ...items] = propItems
  const toggleItems = () => {
    setIsOpen((prev) => !prev)
  }

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside)

    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  return (
    <div css={[styles.container, style]} ref={containerRef}>
      <DropdownItem
        css={itemCss}
        icon={mainItem.icon}
        text={mainItem.text}
        onClick={toggleItems}
        arrowDirection={isOpen ? 'up' : 'down'}
      />
      {isOpen && (
        <div css={styles.dropDown}>
          {items.map((item) => (
            <DropdownItem
              key={`${item.text}-${item.icon?.iconName || item.icon || 'item'}`}
              css={itemCss}
              icon={item.icon}
              text={item.text}
              onClick={() => {
                setIsOpen(false)
                item.onClick()
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
}

DropDown.propTypes = {
  items: PropTypes.array,
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  itemCss: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}
export default DropDown
